import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScreenshotService {

  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;

  
  constructor(private http:HttpClient) { }

  public getScreenshots(filterParams={}):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/screenshots/screenshotdetails`,{params:filterParams,observe:'response'});
  }

  public deleteScreenshot(id:string):Observable<any>{
    let params = { id: id};
    return this.http.delete(`${this.REST_API_SERVER}/screenshots/delete`, {params: params});
  }
}
